import React from "react";
import { Link } from "react-router-dom";
import { Typography, Grid } from "@material-ui/core";
import { Button } from "antd";
import RecentNews from "../RecentNews";
import { ABOUT_ANCHOR, ABOUT_SUMMARY } from "../PanduAbout/aboutContent";


/**
 * HeroHeader – full-width split hero for Rangia College homepage.
 *
 * Left  → RecentNews carousel (fetches BANNER_IMAGES via PostData internally)
 * Right → looping video with an "About" overlay card on top
 */
export default function HeroHeader() {
  const CRIMSON = "#B22222";
  const heroHeight = 520;

  return (
    <div style={{ width: "100%", overflow: "hidden" }}>
      <Grid container style={{ minHeight: heroHeight }}>

        {/* ════════════════════════════════════════
            LEFT — RecentNews banner carousel
        ════════════════════════════════════════ */}
        <Grid
          item
          xs={12}
          sm={12}
          md={7}
          lg={7}
          style={{ position: "relative", overflow: "hidden", minHeight: heroHeight }}
        >
          {/* stretch the carousel to fill the full panel height */}
          <div style={{ height: "100%" }}>
            <RecentNews />
          </div>

          {/* college name badge overlaid at top-left */}
          {/* <div
            style={{
              position: "absolute",
              top: 24,
              left: 24,
              zIndex: 10,
              background: "rgba(25,47,89,0.82)",
              backdropFilter: "blur(6px)",
              borderRadius: 6,
              padding: "10px 18px",
              display: "inline-flex",
              flexDirection: "column",
              pointerEvents: "none",
            }}
          >
            <Typography
              variant="h6"
              style={{
                color: "white",
                fontWeight: 700,
                fontSize: 18,
                lineHeight: 1.2,
                margin: 0,
              }}
            >
              Rangia College
            </Typography>
            <Typography
              variant="caption"
              style={{ color: "#B0C4DE", fontSize: 11, letterSpacing: 1 }}
            >
              Est. 1963 · Kamrup, Assam
            </Typography>
          </div> */}
        </Grid>

        {/* ════════════════════════════════════════
            RIGHT — video + about overlay
        ════════════════════════════════════════ */}
        <Grid
          item
          xs={12}
          sm={12}
          md={5}
          lg={5}
          id={ABOUT_ANCHOR}
          style={{ position: "relative", minHeight: heroHeight, overflow: "hidden", scrollMarginTop: 90 }}
        >
          {/* background video fills the entire right panel */}
          <video
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
              
            }}
          >
            <source src="/videos/RC-video.mp4" type="video/mp4" />
          </video>

          {/* semi-transparent overlay so text is readable */}
          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(3, 3, 3, 0.72)",
            }}
          />

          {/* About content card sitting on top of the video */}
          <div
            style={{
              position: "relative",
              zIndex: 2,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              padding: "36px 32px",
              boxSizing: "border-box",
            }}
          >
            {/* thin accent line */}
            <div
              style={{
                width: 48,
                height: 3,
                backgroundColor: CRIMSON,
                borderRadius: 2,
                marginBottom: 16,
              }}
            />

            <Typography
              variant="h5"
              style={{
                color: "white",
                fontWeight: 700,
                fontSize: 22,
                lineHeight: 1.25,
                marginBottom: 14,
              }}
            >
              About The College
            </Typography>

            <Typography
              variant="body2"
              style={{
                color: "rgba(255,255,255,0.88)",
                fontSize: 14.5,
                lineHeight: 1.75,
                textAlign: "justify",
                marginBottom: 24,
              }}
            >
              {ABOUT_SUMMARY}
            </Typography>

            <div style={{ display: "flex", gap: 12, marginTop: 10}}>
              <Link to="/aboutus/about">
                <Button
                  type="primary"
                  style={{
                    backgroundColor: CRIMSON,
                    borderColor: CRIMSON,
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 13,
                    height: 36,
                    paddingLeft: 20,
                    paddingRight: 20,
                  }}
                >
                  Read More
                </Button>
              </Link>
              <Link to="/notifications/academic">
                <Button
                  style={{
                    backgroundColor: "transparent",
                    borderColor: "rgba(255,255,255,0.5)",
                    color: "white",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 13,
                    height: 36,
                    paddingLeft: 20,
                    paddingRight: 20,
                  }}
                >
                  Notices
                </Button>
              </Link>
            </div>

            {/* quick-stat strip at the bottom */}
            <div
              style={{
                display: "flex",
                gap: 0,
                marginTop: 32,
                borderTop: "1px solid rgba(255,255,255,0.18)",
                paddingTop: 20,
              }}
            >
              {[
                { value: "60+", label: "Years of Excellence" },
                { value: "5000+", label: "Students" },
                { value: "NAAC", label: "Accredited" },
              ].map((stat, i, arr) => (
                <div
                  key={stat.label}
                  style={{
                    flex: 1,
                    textAlign: "center",
                    borderRight:
                      i < arr.length - 1
                        ? "1px solid rgba(255,255,255,0.18)"
                        : "none",
                    paddingRight: i < arr.length - 1 ? 8 : 0,
                  }}
                >
                  <Typography
                    style={{
                      color: "white",
                      fontWeight: 700,
                      fontSize: 20,
                      lineHeight: 1,
                      marginBottom: 4,
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    style={{ color: "rgba(255,255,255,0.65)", fontSize: 11 }}
                  >
                    {stat.label}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}